export const REG_BITACORA_NOTIF_LOADING = 'bitacoraNotificacion/REG_BITACORA_NOTIF_LOADING';
export const REG_BITACORA_NOTIF_SUCCESS = 'bitacoraNotificacion/REG_BITACORA_NOTIF_SUCCESS';
export const REG_BITACORA_NOTIF_FAILURE = 'bitacoraNotificacion/REG_BITACORA_NOTIF_FAILURE';
export const EXCEL_BITACORA_NOTIF_LOADING = 'bitacoraNotificacion/EXCEL_BITACORA_NOTIF_LOADING';
export const EXCEL_BITACORA_NOTIF_SUCCESS = 'bitacoraNotificacion/EXCEL_BITACORA_NOTIF_SUCCESS';
export const EXCEL_BITACORA_NOTIF_FAILURE = 'bitacoraNotificacion/EXCEL_BITACORA_NOTIF_FAILURE';
